<template>
    <div id="detail-clinic">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">Detail Group - {{ user.fullName }}</h4></div>
                </div>
            </div>
            <div class="modal-header with-nav">
                <ul class="nav nav-tabs">
                    <li class="tab-item" :class="(selectedTab === tab.value ? 'active': '') + ' tab-user'+ tab.value "
                        @click="selectTab(tab.value)" v-for="tab in listTab"><a href="javascript:void(0)">{{ tab.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="content-tab">
                <tab-account-setting v-if="selectedTab === 1"
                                     :userInfo="userInfo"
                                     :payments="payments"
                                     :profile="profile"
                                     :addressBillings="addressBillings"
                                     :checkingAccounts="checkingAccounts"
                                     :disabledForm="disabledForm"
                                 >
                </tab-account-setting>

                <tab-general-info
                        v-if="selectedTab === 2"
                        :profile="profile"
                        :disabledForm="disabledForm"
                >
                </tab-general-info>

                <tab-contact-info
                        v-if="selectedTab === 3"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-contact-info>
            </div>
            <div slot="footer">
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin'
import TabAccountSetting from './tab-group/TabAccountSetting'
import TabGeneralInfo from './tab-group/TabGeneralInfo'
import TabContactInfo from './tab-group/TabContactInfo'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'DetailGroup',
  components: { TabAccountSetting, TabGeneralInfo, TabContactInfo },
  props: {
    user: {}
  },
  mixins: [ CommonMixin],
  data () {
    return {
      modal: false,
      selectedTab: 1,
      listTab: [
        {
          name: 'Group Setting',
          value: 1
        },
        {
          name: 'General Info',
          value: 2
        },
        {
          name: 'Contact Info',
          value: 3
        }
      ],

      userInfo: {},
      payments: [],
      addressBillings: [],
      checkingAccounts: [],
      profile: {}
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getInfoAccount()
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    },
    selectTab (value) {
      this.selectedTab = Number(value)
    },
    async getInfoAccount () {
      try {
        let response = await httpClient.get('/users/detail-user/' + this.user.id + '?type=group')
        if (response.data.s === 200) {
          this.userInfo = response.data.data.user
          this.profile = response.data.data.profile
          this.payments = response.data.data.payments
          this.addressBillings = response.data.data.addressBillings
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">
    .tab-item {
        cursor: pointer;
    }

    .tab-user1 {
        width: 150px;
    }

    .tab-user2 {
        width: 150px;
    }

    .tab-user3 {
        width: 160px;
    }

    .tab-user4 {
        width: 220px;
    }

    .tab-user5 {
        width: 150px;
    }
    .tab-user5 {
        width: 165px;
    }
</style>
